import React, { useMemo } from "react";
import { FormHelperText, FormControl } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { FormikProps } from "formik";
import dayjs, { Dayjs } from "dayjs";

export interface AbstractDateTimePickerProps {
    value?: Dayjs | null,
    label: string,
    name?: string,
    error?: string | React.ReactNode,
    submitHappen?: boolean,
    onChange?: (value: Dayjs | null) => void,
    formik?: FormikProps<any>,
    disabled?: boolean
    format?: string
}

export function DateTime({
                             name,
                             submitHappen,
                             formik,
                             value,
                             label,
                             error,
                             onChange,
                             disabled,
                             format = "DD-MM-YYYY HH:mm"
                         }: AbstractDateTimePickerProps) {
    const id = useMemo(() => Math.random().toString(), []);

    if (formik && !name) {
        alert("name not defined, while formik defined");
    }

    const errorToDisplay = formik
        // @ts-ignore
        ? (submitHappen || formik.touched[name!]) && formik.errors[name!]
        : error;

    const valueCandidate = formik ? formik?.values[name!] : value;
    const fieldValue = useMemo(() => {
        if (!valueCandidate) return null;

        if (dayjs.isDayjs(valueCandidate)) {
            return valueCandidate;
        }

        return dayjs(valueCandidate);
    }, [valueCandidate]);


    return (
        <FormControl fullWidth>
            <DateTimePicker
                disabled={disabled}
                label={label}
                value={fieldValue}
                ampm={false}
                format={format}

                onChange={(newValue, a) => {
                    if(newValue && newValue.isValid() && fieldValue === null) {
                        newValue = newValue.set("hour", 12)
                            .set("minute", 0)
                            .set("second", 0)
                            .set("millisecond", 0)
                    }

                    if (onChange) {
                        onChange(newValue);
                    } else if (formik && name) {
                        formik.setFieldValue(name, newValue);
                    }
                }}
                slotProps={{
                    textField: {
                        id,
                        color: (fieldValue && !fieldValue.isValid()) ? 'error' : undefined,
                        name,
                        error: Boolean(errorToDisplay || (fieldValue && !fieldValue.isValid())),
                    },
                }}
            />

            {(errorToDisplay || (fieldValue && !fieldValue.isValid())) && (
                //@ts-ignore
                <FormHelperText error>{errorToDisplay || (fieldValue && !fieldValue.isValid() ? "Date Invalid" : null)}</FormHelperText>
            )}
        </FormControl>
    );
}